import { Icon, SvgIconType } from '@aqarmap/aqarmap-ui';

const DetailsItem = ({
  iconName,
  text,
}: {
  iconName: SvgIconType;
  text: string;
}) => {
  return (
    <div className="flex gap-x">
      <Icon name={iconName} className="text-gray__dark_2" />
      <p className="truncate text-body_2 text-gray__dark_2">{text}</p>
    </div>
  );
};

export default DetailsItem;
